import type { StoreApi, UseBoundStore } from "zustand"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const storeCache = new Map<string, UseBoundStore<StoreApi<any>>>()

/**
 * Creates namespaced store instances per sessionType to isolate state between module variants.
 *
 * @param storeKey - Unique identifier for the store type (e.g., "ai-explorer")
 * @param sessionType - Session type identifier (e.g., "variant-a", "variant-b")
 * @param createStoreFn - Factory function that creates a new store instance
 * @returns Zustand store hook for the specific sessionType
 */
export function createNamespacedStore<T>(
  storeKey: string,
  sessionType: string,
  createStoreFn: () => UseBoundStore<StoreApi<T>>
): UseBoundStore<StoreApi<T>> {
  const key = `${storeKey}:${sessionType}`

  if (!storeCache.has(key)) {
    storeCache.set(key, createStoreFn())
  }

  return storeCache.get(key)!
}

/**
 * Clears a specific store instance from the cache.
 * Useful for cleanup or resetting specific module state.
 */
export function clearNamespacedStore(storeKey: string, sessionType: string): void {
  const key = `${storeKey}:${sessionType}`
  storeCache.delete(key)
}
